import React, { useContext } from 'react';
import { Helmet } from 'react-helmet-async';

import { HeadOwnedByServerContext } from '../../context/HeadOwnedByServerContext';
import { getDynamicBranding } from '../../theme/theme';

interface OwnProps {
  title: string;
  description: string;
  type?: string;
  image?: string;
  imageAlt?: string;
  imageType?: string;
  noIndex?: boolean;
}

const PageMeta: React.FC<OwnProps> = (props) => {
  const {
    title,
    description,
    type = 'website',
    image,
    imageAlt,
    imageType,
    noIndex = false,
  } = props;
  // On server-rendered pages the Vike +Head.tsx owns these tags - see
  // HeadOwnedByServerContext.
  const headOwnedByServer = useContext(HeadOwnedByServerContext);
  const { brand } = getDynamicBranding();
  const fullTitle = `${title} - ${brand}`;
  const url =
    typeof window !== 'undefined'
      ? `${window.location.origin}${window.location.pathname}`
      : undefined;

  if (headOwnedByServer) return null;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      {!noIndex && url && <link rel="canonical" href={url} />}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      {url && <meta property="og:url" content={url} />}
      {image && <meta property="og:image" content={image} />}
      {image && (
        <meta property="og:image:alt" content={imageAlt ?? fullTitle} />
      )}
      {image && imageType && (
        <meta property="og:image:type" content={imageType} />
      )}
    </Helmet>
  );
};

export default PageMeta;
